import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { isDefined } from '../../commons/is-defined';

export function mapDiseaseFromLocation(
  input: ParagraphListingDiseaseFromLocationFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'LinkList'> {
  return {
    key: 'LinkList',
    input: function useListingDiseaseFromLocation() {
      return [
        {
          title: input.title,
          items: input.diseaseList
            ?.sort((a, b) =>
              a && b && a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1,
            )
            .filter(isDefined)
            .map((item) => ({
              Link: buildLink({ href: item.path }),
              title: item.title,
            })),
        },
        200,
      ];
    },
  };
}
